/* The default serves the existing report; reportEndpoints selects corporate deployments. */
const REPORT_DOWNLOAD_CONFIG = {
  endpointUrl: "https://script.google.com/macros/s/AKfycbx9y6dhrE36bvlL8c-t8GIfYkMv7QKvr3ud9urByiwFaDATMM2SOQ54HzOs1olS3oH67A/exec",
  reportEndpoints: {
    "drone-report-202608": "https://script.google.com/macros/s/AKfycbz3o_oqSgP191PcWmsMJY9ItF9A0DPY8s7Ck7jq_d3NXF0QNgd753jNTo1h2bJUqJJkeQ/exec",
  },
}
